export default __webpack_public_path__ + "static/media/trylleby-property-10.7dbc0208.jpg";